module.exports = __webpack_public_path__ + "static/media/arrow-left-grey.6e29c97a.svg";